import { Drawer, ListItem, List, ListItemText } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import colors from "../../constants/colors";
import { useHistory } from "react-router-dom";
import {
	toUserListPage,
	toServiceMessagingPage,
	toCLELoggerTestingPage,
	toTestReportsPage,
	toServiceLogLevelPage,
} from "../../router/navigation";
import { includes } from "../../utils";
import { POW_FEATURES, hasPowFeature } from "../../services/powFeatures.service";

const useStyles = makeStyles(() => ({
	drawer: {
		marginTop: "58px",
		width: "150px",
		backgroundColor: colors.gray100,
	},
}));

/**
 * This Component is the side navigation bar for the administration sub pages.
 * It utilizes react router navigation to switch the pages.
 */
export const AdministrationNavigationBar = () => {
	const classes = useStyles();
	const history = useHistory();
	return (
		<Drawer
			className={classes.drawer}
			variant="permanent"
			anchor="left"
			classes={{
				paper: classes.drawer,
			}}
		>
			<List>
				{hasPowFeature(POW_FEATURES.pdpAdminUsers) && (
					<ListItem
						button
						key="users"
						selected={includes(window.location.pathname, "Users")}
						onClick={() => {
							history.push(toUserListPage());
						}}
					>
						<ListItemText>Users</ListItemText>
					</ListItem>
				)}
				{hasPowFeature(POW_FEATURES.pdpAdminUsers) && (
					<ListItem
						button
						key="service-messaging"
						selected={includes(window.location.pathname, "ServiceMessaging")}
						onClick={() => {
							history.push(toServiceMessagingPage());
						}}
					>
						<ListItemText>Service Messaging</ListItemText>
					</ListItem>
				)}
				{hasPowFeature(POW_FEATURES.pdpAdminCLELogger) && (
					<ListItem
						button
						key="cleLogger-test-page"
						selected={includes(window.location.pathname, "CLELogger")}
						onClick={() => {
							history.push(toCLELoggerTestingPage());
						}}
					>
						<ListItemText>CLE Logger Testing</ListItemText>
					</ListItem>
				)}
				{hasPowFeature(POW_FEATURES.pdpAdminTestReports) && (
					<ListItem
						button
						key="test-reports"
						selected={includes(window.location.pathname, "TestReports")}
						onClick={() => {
							history.push(toTestReportsPage());
						}}
					>
						<ListItemText>Test Reports</ListItemText>
					</ListItem>
				)}
				{hasPowFeature(POW_FEATURES.pdpAdminServiceLogLevels_View) && (
					<ListItem
						button
						key="service-log-levels"
						selected={includes(window.location.pathname, "ServiceLogLevel")}
						onClick={() => {
							history.push(toServiceLogLevelPage());
						}}
					>
						<ListItemText>Service log Levels</ListItemText>
					</ListItem>
				)}
			</List>
		</Drawer>
	);
};
